export const GET_PURCHASE_DETAILS_LOADING = 'header/account/GET_PURCHASE_DETAILS/LOADING';

export const GET_PURCHASE_DETAILS_SUCCESS = 'header/account/GET_PURCHASE_DETAILS/SUCCESS';

export const GET_PURCHASE_DETAILS_ERROR = 'header/account/GET_PURCHASE_DETAILS/ERROR';
